module.exports = __webpack_public_path__ + "static/media/safety-orange.04aaa368.svg";